export const isSettingEnabled = (value) => value === 'true';



// WEBPACK FOOTER //
// ./src/event/setting-enabled.js